import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars, faTimes, faStar } from "@fortawesome/free-solid-svg-icons";
import styles from "./Landing.module.css";

const Header = ({ onNavClick, activeSection }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: "BLOGS", sectionKey: "blogsRef" },
    { label: "ABOUT", sectionKey: "aboutRef" },
    { label: "DR. MONIKA SHARMA", sectionKey: "doctorRef" },
  ];

  const handleLinkClick = (sectionKey) => {
    if (window.location.pathname !== "/") {
      window.location.href = `/#${sectionKey}`;
    } else if (onNavClick && typeof onNavClick === "function") {
      onNavClick(sectionKey);
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        {/* Left: Brand Text */}
        <Link to="/" className={styles.brandLogo}>
          <span>REFORMME HEALTHCARE</span>
        </Link>

        {/* Center: Desktop Navigation Links */}
        <nav className={styles.desktopNav}>
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => handleLinkClick(item.sectionKey)}
              className={`${styles.navLink} ${activeSection === item.sectionKey ? styles.navLinkActive : ""
                }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Right: Controls & Login Button */}
        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", flexShrink: 0 }}>
          <Link to="/login" className={`${styles.loginBtn} ${styles.headerLoginBtn}`}>
            <FontAwesomeIcon icon={faUser} />
            <span>Login</span>
          </Link>

          {/* Mobile Hamburger Button */}
          <button
            className={styles.hamburgerBtn}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle Navigation Menu"
          >
            <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu (Floating Glass UI below pill) */}
      {isMobileMenuOpen && (
        <nav className={`${styles.mobileNav} ${styles.mobileNavOpen}`}>
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => handleLinkClick(item.sectionKey)}
              className={styles.mobileDropdownItem}
            >
              <span>{item.label}</span>
            </button>
          ))}
          {/* Patient Reviews — mobile only */}
          <Link
            to="/reviews"
            onClick={() => setIsMobileMenuOpen(false)}
            className={styles.mobileDropdownItem}
          >
            <FontAwesomeIcon icon={faStar} />
            <span>PATIENT REVIEWS</span>
          </Link>
          <Link
            to="/login"
            onClick={() => setIsMobileMenuOpen(false)}
            className={styles.mobileDropdownItem}
          >
            <FontAwesomeIcon icon={faUser} />
            <span>LOGIN</span>
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
